import React from "react";
import './app.component.scss'
import SidebarMenu from "./sidebar-menu/sidebar-menu.component";
import HeaderComponent from "./header/header.component";
import CreditsHistoryComponent from "./base-content/credits-history/credits-history.component";

const CreditsHistoryApp = () => {
    return (
<div className="container-fluid">
  <div className="row">
      <div className="col-sm-auto sidebar-menu sticky-top">
        <SidebarMenu />
      </div>
      <div className="col-sm min-vh-100 p-0">
        <div>
            <HeaderComponent />
            <CreditsHistoryComponent />
        </div>
      </div>
  </div>
</div>
    );
}

export default CreditsHistoryApp;